import styles from './index.module.scss';
import { FeatureCard } from './FeatureCard';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';
import { useFm } from '@web3/base-hooks';
import { useMemo } from 'react';

export const ExchangeSection = () => {
  const fm = useFm();
  const {
    solConfig: { exchange },
  } = useBbSolConfigContext();

  const title = useMemo(() => {
    const text = fm('notReadyForDefi') ?? '';
    return text.split(/\?|？/);
  }, [fm]);

  if (!exchange || exchange.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.header}>
          <>
            <div className={styles.mobileTitle}>
              <div className={styles.first}>{title?.[0] ?? ''}</div>
              <div className={styles.second}>{title?.[1] ?? ''}</div>
            </div>
            <div className={styles.title}>{fm('notReadyForDefi')}</div>
          </>
        </div>

        <div className={styles.content}>
          {exchange.map((item) => (
            <FeatureCard key={item.title} data={item} />
          ))}
        </div>
      </div>
    </div>
  );
};
